import React from "react";
import useBreakpoints from "@/modules/hooks/use-breakpoints";
import polyglot from "@/utils/polyglot";
import { artwork } from "../../assets/categories";
import { borderWidth, colors, shadows, spacings } from "../../assets/themes";
import Block from "@/components/block";
import List from "@/components/list";
import Shape from "@/components/shape";
import { LIST } from "@/components/styles/variants/list";
import { SHAPE } from "@/components/styles/variants/shape";

const MainCategoryItem = React.memo(
  ({ elem, onClick }) => {
    const breakpoints = useBreakpoints();
    return (
      <Block marginX={{ xs: `calc(${spacings.m} * -1)`, sm: 0 }}>
        <List.Item
          chevron
          css={breakpoints.get({
            xs: undefined,
            sm: `
            box-shadow: ${shadows.xs};
            border: solid ${borderWidth.s} ${colors.border};
            &:hover {
              img {
                transform: scale(1.1);
              }
            }
          `,
          })}
          divider={breakpoints.get({ xs: true, sm: false })}
          key={elem.id}
          LeftComponent={() => (
            <Shape.Large
              backgroundColor="transparent"
              css={`
                overflow: hidden;
                margin: ${spacings.xs} 0;
              `}
              shape={SHAPE.SHAPE.ROUND}
              size={breakpoints.get({
                xs: SHAPE.SIZE.MEDIUM,
                md: SHAPE.SIZE.LARGE,
              })}
            >
              <img
                alt={polyglot.t(`categories.${elem.id}.name`)}
                css={`
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  transform: scale(1);
                  transition: 0.1s ease-in-out;
                  object-position: right bottom;
                `}
                src={elem.id > 10_000 ? artwork[29] : artwork[elem.id]}
              />
            </Shape.Large>
          )}
          onClick={onClick}
          shape={breakpoints.get({ xs: undefined, sm: LIST.SHAPE.ROUND })}
          size={LIST.SIZE.LARGE}
          withGutters
        >
          <List.Elem.Title
            className={breakpoints.get({
              xs: "",
              sm: "ml-2 font-size-sm-4",
            })}
          >
            {polyglot.t(`categories.${elem.id}.name`)}
          </List.Elem.Title>
        </List.Item>
      </Block>
    );
  },
  () => true
);

export default MainCategoryItem;
